import { useMemo } from 'react';

const BVT_SUBDOMAINS = ['localhost', 'li3', 'intelligence'];

/**
 * @param {string} overrideSubdomain
 */
export const useSubdomainInfo = (overrideSubdomain = '') => {
  const subdomain = useMemo(() => {
    if (overrideSubdomain) {
      return overrideSubdomain;
    }
    if (typeof window === 'undefined') {
      return '';
    }
    return window.location.hostname.split('.')[0];
  }, [overrideSubdomain]);

  const isBVT = useMemo(() => BVT_SUBDOMAINS.includes(subdomain), [subdomain]);

  return { subdomain, isBVT };
};
